<template>
    <div class="container">
        <section class="section">
        <div v-if="currentRoute == 'units'">
        <div class="columns">
            <div class="column is-2">
                <field-select label-text="Fangstår" v-model="sampleYear" v-bind:options="sampleYears" />
            </div>
            <div class="column is-10">
                <FylkeVassdrag :model="fylkeVassdrag"></FylkeVassdrag>
            </div>

            <!-- <div class="column is-2">
                <field-select label-text="Type fiske" v-model="fishingTypeId" v-bind:options="fishingTypes" />
            </div>
            <div class="column is-2">
                <label class="label">Art</label>
                <v-select multiple label="name" v-model="selectedSpecies" :options="speciesTypes"
                    placeholder="Velg art(er)" />
            </div>
            <div class="column is-1">
                <label class="label">Eksporter</label>
                <div class="dropdown" :class="{ 'is-active': dropdownExpanded }"
                    @click="dropdownExpanded = !dropdownExpanded">
                    <div class="dropdown-trigger">
                        <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
                            <span class="icon is-small">
                                <i class="fas fa-download" aria-hidden="true"></i>
                            </span>
                            <span class="icon is-small">
                                <i class="fas fa-angle-down" aria-hidden="true"></i>
                            </span>
                        </button>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                            <a @click="downloadReport('Skjellprøver')" class="dropdown-item">
                                Mottatte skjellprøver
                            </a>
                            <a @click="downloadReport('OppleggAnalyse')" class="dropdown-item">
                                Status opplegg/analyse
                            </a>

                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        
        <div>
            <button type="button" class="button is-info is-pulled-right mb-2" @click="showFormModal()">
                <span class="icon is-small">
                    <i class="fa fa-plus"></i>
                </span>
                <span>Ny boks</span>
            </button>
        </div>

        <table class="is-hidden-mobile table is-fullwidth is-bordered is-striped is-narrow">
            <thead class="has-background-info-light">
                <tr>
                    <th>Fylke</th>
                    <th>Vassdrag</th>
                    <th>Fangstår</th>
                    <th>Boksnr</th>
                    <th>Reol</th>
                    <th><abbr title="Laks">LA</abbr></th>
                    <th><abbr title="Aure">AU</abbr></th>
                    <th><abbr title="Røye">RØ</abbr></th>
                    <th><abbr title="Pukkellaks">PU</abbr></th>
                    <th><abbr title="Regnbueørret">RE</abbr></th>
                    <th><abbr title="Annet">AN</abbr></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(reg, index) in filteredList" :key="index">
                    <td> {{ reg.countyName }}</td>
                    <td>{{ reg.vassdragName }}</td>
                    <td>{{ reg.fiskeskjellSamplesAggregated.sampleYears }}</td>
                    <td>{{ reg.countyId }}-{{ reg.serialNumber }}</td>
                    <td>{{ reg.skjellarkivReolId }}</td>
                    <td>{{ reg.fiskeskjellSamplesAggregated.laks }}</td>
                    <td>{{ reg.fiskeskjellSamplesAggregated.aure }}</td>
                    <td>{{ reg.fiskeskjellSamplesAggregated.røye }}</td>
                    <td>{{ reg.fiskeskjellSamplesAggregated.regnbueørret }}</td>
                    <td>{{ reg.fiskeskjellSamplesAggregated.pukkellaks }}</td>
                    <td>{{ reg.fiskeskjellSamplesAggregated.unknownSpecies }}</td>
                    <td><a @click="showUnit(reg)">Velg</a></td> 
                </tr>
            </tbody>
        </table>
    </div>

    <form-modal ref="formModal" title="Opprett ny boks">
            <component :is="leggTilBoksForm" :model="boks" @formSubmitted="leggTilBoks" ></component>
        </form-modal>

    <div v-if="currentRoute == 'unit'">
        <Unit></Unit>
    </div>

</section>
    </div>
</template>

<script>
import api from "@/api/basicApi.js";
import FylkeVassdrag from '@/components/grouped/FylkeVassdrag.vue';
import fishingTypeEnum from "@/enums/FishingTypeEnum";
import speciesEnum from "@/enums/SpeciesEnum";
import { PROVEBASE_CONFIG } from "@/../config.js";
import Unit from "@/components/archive/Unit.vue"
import FormModal from '@/components/modals/FormModal.vue';
import LeggTilBoks from '@/components/archive/LeggTilBoks.vue'

export default {

    data: function () {
        return {
            registreringer: [],
            fylkeVassdrag: {
                fylkeId: '',
                vassdragId: null
            },
            fishingTypes: fishingTypeEnum,
            speciesTypes: speciesEnum,
            selectedSpecies: [],
            fishingTypeId: null,
            sampleYears: [],
            sampleYear: null,
            dropdownExpanded: false,
            selectedUnit: {},
            leggTilBoksForm: LeggTilBoks,
            boks: {
                fylkeVassdrag: {
                fylkeId: '',
                vassdragId: null
                }
            }
        }
    },
    components: {
        FylkeVassdrag, Unit, "form-modal": FormModal, LeggTilBoks
    },
    mounted() {
        let self = this;
        self.getUnitsAggregert()
        api.fetchData({ url: "Archive/GetSampleYears" })
            .then(res => {
                self.sampleYears = res.data.sampleYears
            });

    },
    computed: {
        currentRoute() {
            return this.$route.name;
        },

        filteredList() {
            if (this.fylkeVassdrag.county != '' || this.fishingTypeId > 0 || this.fylkeVassdrag.vassdragId != null || this.selectedSpecies.length > 0) {
                // Initial filter function always returns true; will be replaced if any conditions are added
                let filterFunction = () => true;

                // Conditions based on fylkeId, fishingTypeId, and vassdragId
                if (this.fylkeVassdrag.fylkeId != '') {
                    const prevFilter = filterFunction;
                    filterFunction = item => prevFilter(item) && item.countyId === this.fylkeVassdrag.fylkeId;
                }

                if (this.fishingTypeId > 0) {
                    const prevFilter = filterFunction;
                    filterFunction = item => prevFilter(item) && item.fishingTypeId === this.fishingTypeId;
                }

                if (this.fylkeVassdrag.vassdragId != null) {
                    const prevFilter = filterFunction;
                    filterFunction = item => prevFilter(item) && item.vassdragId === this.fylkeVassdrag.vassdragId;
                }

                if (this.selectedSpecies.length > 0) {
                    const firstSpeciesCondition = item => item.speciesOversiktVm[this.selectedSpecies[0].id] > 0;

                    // Update filter function to include the first species as an "AND" condition
                    const prevFilter = filterFunction;
                    filterFunction = item => prevFilter(item) && firstSpeciesCondition(item);

                    // If there are additional species, incorporate them as "OR" conditions
                    if (this.selectedSpecies.length > 1) {
                        const additionalSpeciesConditions = this.selectedSpecies.slice(1).map(species =>
                            item => item.speciesOversiktVm[species.id] > 0);

                        const prevFilterWithFirstSpecies = filterFunction;
                        filterFunction = item => prevFilterWithFirstSpecies(item) || additionalSpeciesConditions.some(condition => condition(item));
                    }
                }

                // Use the constructed filter function
                return this.registreringer.filter(filterFunction);
            } else {
                return this.registreringer;
            }
        }
    },
    methods: {
        showUnit(unit) {
            this.selectedUnit = unit
            this.$router.push({ name: 'unit', params: { unitId: unit.id } })
        },

        
        getFishingType(id) {
            return this.fishingTypes[id - 1].name;
        },
        getUnitsAggregert() {
            let self = this
            
                api.fetchData({ url: "Archive/GetStorageUnits/" + self.sampleYear }).then(res => {
                    self.registreringer = res.data
                });
            
        },
        downloadReport(type) {
            if (this.sampleYear) {
                api.fetchData({ url: "MottakFiskeskjellOversikt/GetEncryptedToken" }).then(res => {
                    let tokenFromServer = res.data;
                    let queryString = "encryptedToken=" + tokenFromServer;
                    queryString += "&sampleYear=" + this.sampleYear + "&countyId=" + this.fylkeVassdrag.fylkeId
                        + "&vassdragId=" + this.fylkeVassdrag.vassdragId + "&fishingTypeId=" + this.fishingTypeId

                    this.selectedSpecies.forEach(s => { queryString += "&species=" + s.name })

                    if (type == "OppleggAnalyse") {
                        window.location.href = `${PROVEBASE_CONFIG.API_URL}/` + "MottakFiskeskjellOversikt/OppleggAnalyseReport?" + queryString;
                    } else {
                        window.location.href = `${PROVEBASE_CONFIG.API_URL}/` + "MottakFiskeskjellOversikt/VassdragOversiktReport?" + queryString;
                    }
                })
            }
        },
        showFormModal() {
            this.$refs.formModal.show();
        },
        leggTilBoks(formData) {
            let self = this;
            var boksToSave = {
                countyId: formData.fylkeVassdrag.fylkeId,
                vassdragId: formData.fylkeVassdrag.vassdragId,
                sampleTypeId: formData.sampleTypeId,
                fishingTypeId: formData.fishingTypeId
            }
            api.saveData({url: "Archive/CreateUnit", data: boksToSave}).then(res => {
                self.showUnit(res.data)
            })

            this.$refs.formModal.close();
        }

    },
    watch: {
        'sampleYear'() {
            this.getUnitsAggregert()
        }
    }
};
</script>